import { createFileRoute } from "@tanstack/react-router";

import ProfilePage from "@/app/ProfilePage";

export const Route = createFileRoute("/profile")({
  component: ProfilePage,
});
